import { logbookGateWay } from "../../services/authorizationService";
import * as serviceEndPoints from "../../config/serviceEndPoints";

export const getDashboardData = params => logbookGateWay.get(serviceEndPoints.dashboardEndPoints.getDashboardData, { params });
export const getEventBreakdownByHierarchy = params =>
    logbookGateWay.get(serviceEndPoints.dashboardEndPoints.getEventBreakdownByHierarchy, { params });
